import { useEffect, useState } from "react";
import { Modal, Select, message } from "antd";

import {
  filterOperatorOption,
  listOperators,
  operatorName,
} from "../../../../../../modules/integrations/accounts";
import { Operator } from "@/providers/smarta-accounts/accounts-api-client";
import { useAssignTaxCaseMutation } from "../../../../../api/graphql/mutations/taxCase/assignTaxCase.generated";

const { Option } = Select;

interface AssignTaxCaseModalProps {
  taxCaseId: string;
  open: boolean;
  onClose: () => void;
  onSuccess: () => void;
}

const AssignTaxCaseModal = ({
  taxCaseId,
  open,
  onClose,
  onSuccess,
}: AssignTaxCaseModalProps) => {
  const [operators, setOperators] = useState<Operator[]>([]);
  const [selectedId, setSelectedId] = useState<string | undefined>(undefined);
  const [loading, setLoading] = useState(false);
  const [assignTaxCase] = useAssignTaxCaseMutation();

  useEffect(() => {
    if (open) {
      setOperators([]);
      setSelectedId(undefined);
      listOperators()
        .then((data) => setOperators(data))
        .catch(() => {
          setOperators([]);
          message.error("An error occurred");
        });
    }
  }, [open]);

  const handleOk = async () => {
    if (!selectedId) return;
    setLoading(true);
    try {
      await assignTaxCase({
        variables: { taxCaseId, assignee: selectedId },
      });
      message.success("Mandant zugewiesen");
      onSuccess();
      onClose();
    } catch {
      message.error("An error occurred");
    } finally {
      setLoading(false);
    }
  };

  return (
    <Modal
      title="Mandant zuweisen"
      open={open}
      onOk={handleOk}
      onCancel={onClose}
      okButtonProps={{ disabled: !selectedId, loading }}
      destroyOnClose
    >
      <Select
        showSearch
        style={{ width: "100%" }}
        placeholder="Bearbeiter auswählen"
        value={selectedId}
        onChange={(val) => setSelectedId(val)}
        filterOption={filterOperatorOption(operators)}
      >
        {operators.map((op) => (
          <Option key={op.id} value={op.id}>
            {operatorName(op)}
          </Option>
        ))}
      </Select>
    </Modal>
  );
};

export default AssignTaxCaseModal;
